import Routes from './routes'
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
// Navbar/Footer ficam nos layouts/páginas quando necessário

function App() {
  return (
   <div>

  <ToastContainer
     position="top-right"
     autoClose={5000}
     hideProgressBar={false}
     newestOnTop={false}
     closeOnClick
     rtl={false}
     pauseOnFocusLoss
     draggable
     pauseOnHover
     theme="colored"/>
   
    <Routes />
    
 
   
  
   </div>
  );
}

export default App;



